import {
  AfterViewInit,
  Component,
  OnInit, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauXuLyService} from '../../../../service/yeucau/service-yeucauxuly';
import {ThongBaoService} from '../../../../service/info/service-thongbao';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {environment} from '../../../../../environments/environment';
import {MeetingXuLyService} from '../../../../service/info/service-meetingxuly';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {CommandUtil} from '../../../../global/commandutil';

@Component({
  selector: 'egov-tonghoplist-giaiquyetsuvu',
  templateUrl: './tonghoplist.component.html',
  encapsulation: ViewEncapsulation.None
})
export class GiaiQuyetSuVuTongHopListComponent implements OnInit, AfterViewInit {
  public totalToTrinhXuLy: number = 0;
  public totalToTrinhNhan: number = 0;
  public totalToTrinhDangSoan: number = 0;
  public totalYeuCauGui: number = 0;
  public totalYeuCauNhan: number = 0;
  public totalYeuCauDangSoan: number = 0;
  public totalCuocHop:  number = 0;
  public totalCuocHopChuaXem: number = 0;
  public totalCuocHopChuaXemYKien: number = 0;
  public totalThongBao: number = 0;
  public totalThongBaoChuaXem: number = 0;
  public totalTCChuaXuLy: number = 0;
  public totalTCDangXuLy: number = 0;
  public totalTCHoanThanh: number = 0;
  public totalTCChuaXem: number = 0;
  public totalTCChuaXemYKien: number = 0;
  public ty: string = '';
  public totalYCChuaXuLy: number = 0;
  public totalYCDangXuLy: number = 0;
  public totalYCHoanThanh: number = 0;
  public totalYCChuaXem: number = 0;
  public totalYCChuaXemYKien: number = 0;
  public language = language;
  public permissionSoanToTrinh: boolean = false;
  public permissionToTrinhGui: boolean = false;
  public permissionToTrinhNhan: boolean = false;
  public permissionToTrinhDangSoan: boolean = false;

  public permissionSoanYeuCau: boolean = false;
  public permissionYeuCauGui: boolean = false;
  public permissionYeuCauNhan: boolean = false;
  public permissionYeuCauDangSoan: boolean = false;

  public permissionCuocHopAdd: boolean = false;
  public permissionThamGiaHop: boolean = false;

  public permissionSoanThongBao: boolean = false;
  public permissionDocThongBao: boolean = false;
  public permissionQLThongBao: boolean = false;

  public status: number[] =[
    environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  constructor(
    public toTrinhService: ToTrinhService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public yeuCauService: YeuCauService,
    public yeuCauXuLyService: YeuCauXuLyService,
    public meetingService: MeetingXuLyService,
    public thongBaoService: ThongBaoService,
    public navItemService: NavItemService,
    public commandUtil: CommandUtil,
    public rolePermissionService: RolePermissionService
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.loadTotal();
    this.navItemService.findALlByStaffId(Sessioncommand.staffId, 1, true).subscribe(
      x => {
        this.permissionSoanToTrinh = x.findIndex(y => y.code === 'TTADD' ) !== -1;
        this.permissionToTrinhDangSoan = x.findIndex(y => y.code === 'TTDANGSOAN' ) !== -1;
        this.permissionToTrinhGui = x.findIndex(y => y.code === 'TTGUI' ) !== -1;
        this.permissionToTrinhNhan = x.findIndex(y => y.code === 'TTNHAN' ) !== -1;
        this.permissionSoanYeuCau = x.findIndex(y => y.code === 'YCADD' ) !== -1;
        this.permissionYeuCauDangSoan = x.findIndex(y => y.code === 'YCDANGSOAN' ) !== -1;
        this.permissionYeuCauGui = x.findIndex(y => y.code === 'YCGUI' ) !== -1;
        this.permissionYeuCauNhan = x.findIndex(y => y.code === 'YCNHAN' ) !== -1;
        this.permissionCuocHopAdd = x.findIndex(y => y.code === 'CHOPADD' ) !== -1;
        this.permissionThamGiaHop = x.findIndex(y => y.code === 'CHOPTGIA' ) !== -1;
        this.permissionSoanThongBao = x.findIndex(y => y.code === 'TBADD' ) !== -1;
        this.permissionDocThongBao = x.findIndex(y => y.code === 'TBDOC' ) !== -1;
        this.permissionQLThongBao = x.findIndex(y => y.code === 'TBQL' ) !== -1;
      }
    );

  }

  public loadTotal()
  {
    this.toTrinhService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhNhan = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, this.commandUtil.chuaXem, '','').subscribe(recordCount => this.totalTCChuaXem = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.dangxuly.toString() + ',' + environment.hoanthanh.toString(), Sessioncommand.staffId, this.commandUtil.chuaXemYKien, '','').subscribe(recordCount => this.totalTCChuaXemYKien = recordCount);

    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCChuaXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCDangXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCHoanThanh = recordCount);
    this.toTrinhService.getCountByKeyword('', environment.soanthao.toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhDangSoan = recordCount);
    this.yeuCauService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauGui = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalYeuCauNhan = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCChuaXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCDangXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCHoanThanh = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, this.commandUtil.chuaXem, '','').subscribe(recordCount => this.totalYCChuaXem = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.dangxuly.toString() + ',' + environment.hoanthanh.toString() , Sessioncommand.staffId, this.commandUtil.chuaXemYKien, '','').subscribe(recordCount => this.totalYCChuaXemYKien = recordCount);

    this.yeuCauService.getCountByKeyword('',  environment.soanthao.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauDangSoan = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1).subscribe(recordCount => this.totalCuocHop = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, this.commandUtil.chuaXem).subscribe(recordCount => this.totalCuocHopChuaXem = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, this.commandUtil.chuaXemYKien).subscribe(recordCount => this.totalCuocHopChuaXemYKien = recordCount);
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId,"egov.info.thongbao").subscribe(
      x => {
        this.thongBaoService.findAllByCountAlert(Sessioncommand.staffId, ( x.findIndex( y => y.action === environment.xemtatca || y.action === environment.toanquyen) !== -1 ? -1 : Sessioncommand.staffId)).subscribe(recordCount => this.totalThongBaoChuaXem = recordCount);
        this.thongBaoService.getCountByKeyword('', ( x.findIndex( y => y.action === environment.xemtatca || y.action === environment.toanquyen) !== -1 ? -1 : Sessioncommand.staffId), -1).subscribe(recordCount => this.totalThongBao = recordCount);
      }
    );


  }

}

